import styled, { css } from 'styled-components';
import {
  ConfiguratorTimelineLock,
  ServicesIconsStripeLogo
} from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { CLASS_COMPONENT, STYLE_DEFAULTS } from '../../common';
import { Text } from './text';

const STRIPE_BLURPLE = '#645cffff';

export function SecurePaymentCaption({ color }: { color?: string }) {
  const { t } = useLingui();

  const halfTransparentColor = getColorWithAlpha(
    color || STYLE_DEFAULTS.textColor,
    0.5
  );

  return (
    <Text
      color={halfTransparentColor}
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'secure-payment-caption'
      })}
    >
      <InlineLockIcon
        component={ConfiguratorTimelineLock}
        size={16}
        fill={halfTransparentColor}
      />
      {t`Secure payments are processed via`}
      <InlineStripeLogo height={16} fill={STRIPE_BLURPLE} />
    </Text>
  );
}

const inlineIconMixin = css`
  display: inline-block;
  vertical-align: text-bottom;
`;

const InlineLockIcon = styled(Icon)`
  ${inlineIconMixin}
  margin-right: 4px;
`;

const InlineStripeLogo = styled(ServicesIconsStripeLogo)`
  ${inlineIconMixin}
  margin-left: 4px;
`;
